<template>
	<div class="box" v-loading="loading" :element-loading-text="$t('bc.bc_50')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="signup">
			{{$t('Register.Register_lbl0')}}
		</div>
		<div class="signup2">
			{{$t('Register.Register_lbl1')}}
		</div>
		<el-row style="margin-top: 20px;">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" label-position="left">
				<el-row>
					<el-col :span="24">
						<el-form-item :label="$t('Register.Register_lbl2')" class="form_title" prop="userid">
							<el-input v-model="ruleForm.userid" style="width: 90%;" type="email"
								placeholder="user@mrhiro.co.jp"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="18">
						<el-form-item :label="$t('Register.Register_lbl3')" class="form_title" prop="code">
							<el-input v-model="ruleForm.code" style="width: 90%;"
								onkeyup="this.value=this.value.replace(/[^\d]/g,'') " maxlength="5" placeholder="CODE">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6" style="" class="code">

						<span v-if="sendconfirm" @click="sendCode">{{codemsg}}</span>
						<span v-else>{{codemsg}}</span>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="18" :xs="24" :sm="18" :md="18" :xl="18" :lg="18">
						<el-form-item :label="$t('Register.Register_lbl5')" class="form_title" prop="password">
							<el-input v-model="ruleForm.password" style="width:90%;" type="password"
								placeholder="PASSWORD"></el-input>
						</el-form-item>

					</el-col>
				</el-row>
				
				<el-row class="pwdbox">
					<el-col :span="24" class="pwdmsg">
						{{$t('Register.Register_lbl6')}}
					</el-col>
				</el-row>
				
				
				<el-row>
					<el-col :span="18" :xs="24" :sm="18" :md="18" :xl="18" :lg="18">
						<el-form-item :label="$t('ReserveCar.ReserveCar_10')" class="form_title" prop="firstname">
							<el-input v-model="ruleForm.firstname" maxlength="16" style="width:90%;"
								:placeholder="$t('ReserveCar.ReserveCar_10')"></el-input>
						</el-form-item>

					</el-col>
				</el-row>
				<el-row>
					<el-col :span="18" :xs="24" :sm="18" :md="18" :xl="18" :lg="18">
						<el-form-item :label="$t('ReserveCar.ReserveCar_11')" class="form_title" prop="secondname">
							<el-input v-model="ruleForm.secondname" maxlength="16" style="width:90%;"
								:placeholder="$t('ReserveCar.ReserveCar_11')"></el-input>
						</el-form-item>

					</el-col>
				</el-row>


				<el-row class="checkbox"  style=" margin-top: 10px;">
					<el-col :span="24">
						<el-checkbox v-model="check">
							<!-- <span class="checktext">{{$t('Register.Register_lbl7')}}</span> -->
						</el-checkbox>
						<span class="checktext" style="margin-left: 10px;"
							@click="dialogTableVisible = true">{{$t('Register.Register_lbl7')}}</span>
					</el-col>
				</el-row>

				<el-row style="text-align: center; margin-top: 20px;">
					<el-col :span="24">
						<el-button class="resetbtn" @click="registerSubmit"> {{$t('Register.Register_lbl8')}}
						</el-button>
					</el-col>
				</el-row>

				<el-row style="margin-top: 20px;text-align: center;">
					<el-col :span="24">
						<span class="btmtext">
							{{$t('Register.Register_lbl9')}}
						</span>
						<span class="btmlogintext" @click="toLogin">
							{{$t('Register.Register_lbl10')}}
						</span>
						<span class="btmtext">
							{{$t('Register.Register_lbl11')}}
						</span>

					</el-col>
				</el-row>
			</el-form>
		</el-row>
		<div class="agree">
			<el-dialog :visible.sync="dialogTableVisible" append-to-body :title="$t('agree.agree1')">
				<div class="agreeheight">
				<!-- <div class="agreetop">{{$t('agree.agree1')}}</div> -->
				<div class="agreetext">
					<p>{{$t('agree.agree2')}}</p>
					<p>{{$t('agree.agree3')}}</p>
					<p>{{$t('agree.agree4')}}</p>
					<p>{{$t('agree.agree5')}}</p>
					<p>{{$t('agree.agree6')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree7')}}</p>
						<p>{{$t('agree.agree8')}}</p>
						<p>{{$t('agree.agree9')}}</p>
						<p>{{$t('agree.agree10')}}</p>
					</div>
					<p>{{$t('agree.agree11')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree12')}}</p>
						<p>{{$t('agree.agree13')}}</p>
						<p>{{$t('agree.agree14')}}</p>
						<p></p>
					</div>
					<p>{{$t('agree.agree16')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree17')}}</p>
						<p>{{$t('agree.agree18')}}</p>
						<p>{{$t('agree.agree19')}}</p>
						<p>{{$t('agree.agree20')}}</p>
					</div>
					<p>{{$t('agree.agree21')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree22')}}</p>
						<p>{{$t('agree.agree23')}}</p>
					</div>
					<p>{{$t('agree.agree24')}}</p>
					<p>{{$t('agree.agree25')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree26')}}</p>
						<p>{{$t('agree.agree27')}}</p>
						<p>{{$t('agree.agree28')}}</p>
					</div>
					<p>{{$t('agree.agree29')}}</p>
					<p>{{$t('agree.agree30')}}</p>
					<p>{{$t('agree.agree31')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree32')}}</p>
						<p>{{$t('agree.agree33')}}</p>
					</div>
					<p>{{$t('agree.agree34')}}</p>
					<p>{{$t('agree.agree35')}}</p>
					<p>{{$t('agree.agree36')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree37')}}</p>
						<p>{{$t('agree.agree38')}}</p>
						<p>{{$t('agree.agree39')}}</p>
						<p>{{$t('agree.agree40')}}</p>
						<p>{{$t('agree.agree41')}}</p>
						<p>{{$t('agree.agree42')}}</p>
						<p>{{$t('agree.agree43')}}</p>
					</div>
					<p>{{$t('agree.agree44')}}</p>
					<p>{{$t('agree.agree45')}}</p>
					<p>{{$t('agree.agree46')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree47')}}</p>
						<p>{{$t('agree.agree48')}}</p>
						<p>{{$t('agree.agree49')}}</p>
						<p>{{$t('agree.agree50')}}</p>
						<p>{{$t('agree.agree51')}}</p>
						<p>{{$t('agree.agree52')}}</p>
						<p>{{$t('agree.agree53')}}</p>
						<p>{{$t('agree.agree54')}}</p>
						<p>{{$t('agree.agree55')}}</p>
						<p>{{$t('agree.agree56')}}</p>
						<p>{{$t('agree.agree57')}}</p>
						<p>{{$t('agree.agree58')}}</p>
					</div>
					<p>{{$t('agree.agree59')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree60')}}</p>
						<p>{{$t('agree.agree61')}}</p>
						<p>{{$t('agree.agree62')}}</p>
						<p>{{$t('agree.agree63')}}</p>
						<p>{{$t('agree.agree64')}}</p>
						<p>{{$t('agree.agree65')}}</p>
					</div>
					<p>{{$t('agree.agree66')}}</p>
					<p>{{$t('agree.agree67')}}</p>
					<p>{{$t('agree.agree68')}}</p>
					<p>{{$t('agree.agree69')}}</p>
					<p>{{$t('agree.agree70')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree71')}}</p>
						<p>{{$t('agree.agree72')}}</p>
						<p>{{$t('agree.agree73')}}</p>
						<p>{{$t('agree.agree74')}}</p>
					</div>
					<p>{{$t('agree.agree75')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree76')}}</p>
						<p>{{$t('agree.agree77')}}</p>
						<p>{{$t('agree.agree78')}}</p>
						<p>{{$t('agree.agree79')}}</p>
						<p>{{$t('agree.agree80')}}</p>
						<p>{{$t('agree.agree81')}}</p>
						<p>{{$t('agree.agree82')}}</p>
					</div>
					<p>{{$t('agree.agree83')}}</p>
					<p>{{$t('agree.agree84')}}</p>
					<p>{{$t('agree.agree85')}}</p>
					<p>{{$t('agree.agree86')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree87')}}</p>
						<p>{{$t('agree.agree88')}}</p>
						<p>{{$t('agree.agree89')}}</p>
						<p>{{$t('agree.agree90')}}</p>
					</div>
					<p>{{$t('agree.agree91')}}</p>
					<p>{{$t('agree.agree92')}}</p>
					<p>{{$t('agree.agree93')}}</p>
					<p>{{$t('agree.agree94')}}</p>
					<p>{{$t('agree.agree95')}}</p>
					<p>{{$t('agree.agree96')}}</p>

					<p>{{$t('agree.agree97')}}</p>
					<p>{{$t('agree.agree98')}}</p>

					<p>{{$t('agree.agree99')}}</p>
					<div class="agreebox">
						<p>{{$t('agree.agree100')}}</p>
						<p>{{$t('agree.agree101')}}</p>
					</div>
					<p>{{$t('agree.agree102')}}</p>
					<p>{{$t('agree.agree103')}}</p>

					<p>{{$t('agree.agree104')}}</p>
					<p>{{$t('agree.agree105')}}</p>

					<p>{{$t('agree.agree106')}}</p>
					<p>{{$t('agree.agree107')}}</p>
					<p style="text-align: right;">{{$t('agree.agree108')}}</p>
				</div></div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Login',
		inject: ['reload'],
		data() {
			// 验证码证规则
			const validateVerifycode = (rule, value, callback) => {
				if (value == '') {
					callback(new Error(this.login.login_7)); //请输入验证码
				} else if (value.length != 5) {
					callback(new Error(this.$t('bc.bc_40')));
				} else {
					callback();
				}
			}

			const validateEmail = (rule, value, callback) => { //请输入账号
				if (value === '') {
					callback(new Error(this.login.login_5));
				}
				var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
				let isok = reg.test(value);
				console.log(isok)
				if (!isok) {
					callback(new Error(this.login.login_6));
				} else {
					callback();
				}
			};

			const validatePwd = (rule, value, callback) => { //请输入密码
				// var reg=(/[A-Za-z].*[0-9]|[0-9].*[A-Z]/)
				var res = (/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,18}$/)
				if (value === '') {
					callback(new Error(this.login.login_10));
					// } else if (value.length < 6 || value.length > 18) {

					// 	callback(new Error(this.$t('bc.bc_9')));
				} else if (!res.test(value)) {

					callback(new Error(this.$t('bc.bc_9')));
				} else {
					callback();
				}
			};
			const validateVerifyfirstname = (rule, value, callback) => { //请输入密码
				if (value === '') {
					callback(new Error(this.$t('Register.Register_lbl27')));
				} else {
					callback();
				}
			};
			const validateVerifysecondname = (rule, value, callback) => { //请输入密码
				if (value === '') {
					callback(new Error(this.$t('Register.Register_lbl28')));
				} else {
					callback();
				}
			};
			// const validateVerifycheck = (rule, value, callback) => { //请输入密码
			// 	if (value === false) {
			// 		callback(new Error(this.$t('Register.Register_lbl28')));
			// 	} else {
			// 		callback();
			// 	}
			// };

			return {
				getcode: '', //接口获取回来的验证码
				loading: false,
				lang: 0,
				ruleForm: {
					userid: '',
					code: '',
					password: '',
					firstname: '',
					secondname: ''
				},
				codemsg: '',
				sendconfirm: true,
				timer: null,
				count: "",
				login: {
					login_5: this.$t('Register.Register_lbl12'),
					login_6: this.$t('Register.Register_lbl13'),
					login_7: this.$t('Register.Register_lbl14'),
					login_10: this.$t('Register.Register_lbl15'),
					login_13: this.$t('Register.Register_lbl16'),
					login_14: this.$t('Register.Register_lbl17'),
					login_15: this.$t('Register.Register_lbl23'),
					login_16: this.$t('Register.Register_lbl22')
				},
				rules: {
					userid: [{ //提示请输入手机号
						trigger: ['blur', 'change'],
						validator: validateEmail
					}],
					password: [{ //提示请输入密码
						trigger: ['blur', 'change'],
						validator: validatePwd
					}],
					code: [{ //提示清输入验证码
						trigger: ['blur', 'change'],
						validator: validateVerifycode
					}],
					firstname: [{ //提示清输入姓
						trigger: 'blur',
						validator: validateVerifyfirstname
					}],
					secondname: [{ //提示清输入姓
						trigger: 'blur',
						validator: validateVerifysecondname
					}],
					// check: [{ //提示清输入姓
					// 	trigger: 'blur',
					// 	validator: validateVerifycheck
					// }],
				},
				check: false,
				dialogTableVisible: false,

			}
		},
		mounted() {
			this.$on('closeRegister', function() {
				this.closeRegister();
			});
		},
		created() {
			this.codemsg = this.$t('Register.Register_lbl4');						
		},



		methods: {

			registerSubmit() {
				let myDate = new Date();
				let yy = myDate.getFullYear()
				let mm = myDate.getMonth() + 1 < 10 ? '0' + myDate.getMonth() + 1 : myDate.getMonth() + 1;
				let dd = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				let hh = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
				let ff = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
				let stime = yy + '年' + mm + '月' + dd + '日' + ' ' + hh + ':' + ff
				console.log(stime)
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						if (this.check) {
							if (this.getcode == this.ruleForm.code) {
								this.loading = true
								this.$api.post(this.$config.Register, {
										// 'YHSEQNUM': localStorage.getItem('YHSEQNUM')
										'sEMAIL': this.ruleForm.userid,
										'sPassword': this.ruleForm.password,
										'sFAMNM': this.ruleForm.firstname,
										'sGIVNM': this.ruleForm.secondname,
										'sTIME': stime,
										'sLNGCT': this.lang
									},
									// 请求成功
									success => {
										this.loading = false
										console.log(success)
										if (success.KKDT[0].code == 200) {
											this.$message({
												message: this.login.login_13,
												type: 'success'
											});
											// this.$message.success(this.login.login_13);
											// this.$emit('registerSubmit')
											this.toLogin()
											// this.reload();
										} else if (success.KKDT[0].code == 100000) {
											this.$message({
												message: this.login.login_16, //该账号已经注册
												type: 'error'
											});
										} else if (success.KKDT[0].code == 500) {
											this.$message({
												message: this.login.login_15, //账号或密码错误
												type: 'error'
											});
										}
									},
									// 请求失败
									error => {
										this.loading = false
										console.log(error)
										console.log("_________我的收藏error")
									}
								)

							} else {
								this.loading = false
								this.$message({
									message: this.$t('bc.bc_53'), //验证码错误
									type: 'error'
								});

							}
						} else {
							this.loading = false
							this.$message({
								message: this.login.login_14, //没勾选
								type: 'error'
							});
						}
					} else {
						this.loading = false
						this.$message({
							message: this.$t('bc.bc_35'), //请求失败
							type: 'error'
						});
					}
				});
			},
			toLogin() {
				this.$emit('toLogin');
			},

			// registerSubmit() {
			// 	this.$emit('registerSubmit')
			// },
			closeRegister() {

				clearInterval(this.timer);
				this.timer = null;
				this.sendconfirm = true;
				this.codemsg = this.$t('Register.Register_lbl4');
				this.ruleForm.userid = ''
				this.ruleForm.code = ''
				this.ruleForm.password = ''
			},
			toRefresh() {
				this.$refs['ruleForm'].resetFields();
			},

			sendCode() {
				let myDate = new Date();
				let yy = myDate.getFullYear()
				let mm = myDate.getMonth() + 1 < 10 ? '0' + myDate.getMonth() + 1 : myDate.getMonth() + 1;
				let dd = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
				let hh = myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours();
				let ff = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();
				let stime = yy + '年' + mm + '月' + dd + '日' + ' ' + hh + ':' + ff
				// console.log(stime)
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				if (this.ruleForm.userid) {
					if (this.ruleForm.firstname) {
						if (this.ruleForm.secondname) {
							this.loading = true
							let curCount = 0;
							let TIME_COUNT = 60;

							this.$api.post(this.$config.Get_Register_Code, {
									'sTIME': stime,
									'sFAMNM': this.ruleForm.firstname,
									'sGIVNM': this.ruleForm.secondname,
									'sEMAIL': this.ruleForm.userid,
									'sLNGCT': this.lang
								},
								// 请求成功
								success => {
									this.loading = false
									console.log(success)
									if (success.KKSTR == 'N') {
										this.$message({
											message: this.$t('Register.Register_lbl29'), //该账号已经注册
											type: 'error'
										});
									} else if (success.KKSTR == 'E') {
										this.$message({
											message: this.$t('bc.bc_39'), //该账号已经注册
											type: 'error'
										});
									} else {
										if (!this.timer) {
											this.count = TIME_COUNT;
											this.timer = setInterval(() => {
												if (this.count > 0 && this.count <= TIME_COUNT) {
													curCount = this.count--;
													this.codemsg = curCount + "s";
													this.sendconfirm = false;
												} else {
													this.sendconfirm = true;
													this.codemsg = this.$t('Register.Register_lbl4');
													clearInterval(this.timer);
													this.timer = null;
												}
											}, 1000);
										}
										this.$message({
											message: this.$t('bc.bc_46'), //发送成功
											type: 'success'
										});
										this.getcode = success.KKSTR
									}
								},
								// 请求失败
								error => {
									this.loading = false
									console.log(error)
								}
							)

						} else {
							this.loading = false
							this.$message({
								message: this.$t('Register.Register_lbl28'), //账号或密码错误
								type: 'error'
							});
						}
					} else {
						this.loading = false
						this.$message({
							message: this.$t('Register.Register_lbl27'), //账号或密码错误
							type: 'error'
						});
					}
				} else {
					this.loading = false
					this.$message({
						message: this.$t('Register.Register_lbl12'), //账号或密码错误
						type: 'error'
					});
				}
			}



		}
	}
</script>

<style scoped>
	@media only screen and (min-width:680px) {
		.signup {
			text-align: center;
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
		}
	}

	@media only screen and (max-width:680px) {
		.signup {
			text-align: center;
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			font-weight: bold;
			color: #000000;
		}

		/deep/ .el-dialog {
			width: 80%;
		}
	}

	.box {
		width: 100%;
		height: 100%;

	}


	.signup2 {
		margin-top: 10px;
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
		text-align: center;

	}

	.pwdmsg {

		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #FF0000;
		line-height: 15px;
		cursor: pointer;
	}

	.resetbtn {
		width: 270px;
		height: 50px;
		background: #000000;
		border-color: #000000;
		font-size: 18px;
		font-family: Noto Sans CJK JP-Black, Noto Sans CJK JP;
		font-weight: 900;
		color: #FFFFFF;

	}

	/deep/ .el-form-item__label {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
		padding: 8px 0;
		line-height: 24px;

	}

	.code {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #FE9C2C;
		cursor: pointer;
		text-decoration: underline;
	}

	.checktext {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
		font-weight: 500;
		color: #000000;
		line-height: 15px;
		word-break: break-all;
		/* margin-left: 10px; */
		cursor: pointer;
	}

	.btmtext {

		font-size: 12px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
		font-weight: 500;
		color: #000000;
	}

	.btmlogintext {

		font-size: 12px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
		font-weight: 500;
		color: #FE9C2C;
		cursor: pointer;
	}

	/deep/ .el-checkbox__label {
		word-break: break-all;
		white-space: normal
	}

	.agreetop {
		text-align: center;
		font-size: 18px;
		font-weight: bold;
	}

	.agreetext {
		text-align: justify;
	}

	.agreetext p {
		margin-bottom: 8px;
	}

	/deep/ .el-dialog {
		height: 70%;
	}
	.agreebox {
		padding-left: 12px;
		box-sizing: border-box;
	}
	.agreeheight{
		width: 100%;
		height: 100%;
		overflow: hidden;
		overflow-y: auto;
	}
	/deep/ .el-dialog__body {
		height: calc(100% - 70px);
		padding-top: 8px;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #666;
		font-size: 20px;
		font-weight: bold;
	}

	/deep/ .el-dialog__title {
		font-size: 20px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000000;
		line-height: 40px;
	}
	
	.pwdbox{
		
		margin-left: 130px;
	}
	
	.checkbox{
		
		margin-left: 130px;
	}
	
	@media only screen and (max-width:680px) {
		.pwdbox{
			
			margin-left: 0px;
		}
		
		.checkbox{
			
			margin-left: 0px;
		}
		
		
		.code {
			font-size: 12px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			font-weight: bold;
			color: #FE9C2C;
			cursor: pointer;
			text-decoration: underline;
		}
		
		
		/deep/
		.el-form-item__error{
			font-size: 10px;
		}
	
	}
	
	
</style>
